/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoLocationEntity } from './geoLocationEntity';
import { UserEventDetailOutputDto } from './userEventDetailOutputDto';
import { SessionKindDto } from './sessionKindDto';
import { ActivityGroupLogoDto } from './activityGroupLogoDto';

export interface EventDetailOutputDto {
  id: string;
  title: string;
  description: string;
  location?: GeoLocationEntity;
  locationAddress: string;
  endLocation?: GeoLocationEntity;
  endLocationAddress?: string;
  maxNbAttendees: number;
  attendeesMode: EventDetailOutputDto.AttendeesModeEnum;
  startDate: string;
  endDate?: string;
  duration: number;
  level: number;
  background?: string;
  group?: ActivityGroupLogoDto;
  joined: boolean;
  full: boolean;
  /**
   * Database id of the sport, what creating an activity expects.
   */
  sportId?: string;
  sportKeyId: string;
  sportKeyIcon: string;
  /**
   * Internationalized text that resolves to a string
   */
  sportTitle: string;
  sessionKind?: SessionKindDto;
  acceptAnyLvl: boolean;
  handiFriendly?: boolean;
  isAdmin: boolean;
  attendees: Array<UserEventDetailOutputDto>;
  nbPlacesLeft: number;
  /**
   * SMA-163: how many people are waiting for a place. A COUNT, never a
   * position: the rule is first come, first served, so nobody holds a rank and
   * a screen must not draw one.
   *
   * Added by hand, like the other three: `generate:sdk` needs a running API,
   * because the Nest swagger plugin only writes these schemas during the
   * webpack build.
   */
  waitingCount: number;
  /** SMA-163: whether the person reading this is on that list. */
  iAmWaiting: boolean;
  /**
   * The optional confirmation threshold (organiser counted in), when the
   * organiser set one, and whether it has been reached. Added by hand like the
   * SMA-163 pair above: `generate:sdk` needs a running API, so a schema the Nest
   * swagger plugin only writes during the webpack build is kept here by hand.
   * `minParticipants` absent means no threshold, so the fiche shows no block;
   * `confirmed` absent reads as false (an app can be older than the API).
   */
  minParticipants?: number;
  confirmed: boolean;
  owner: UserEventDetailOutputDto;
  distance: number;
  pace: string;
  verticalDrop: number;
  status: object;
  isOver: boolean;
  canJoinConversation: boolean;
  type: string;
  costPerParticipant: number;
  isPaidOut: boolean;
  commissionPercent: number;
  routeUrl?: string;
  privacy?: EventDetailOutputDto.PrivacyEnum;
}
export namespace EventDetailOutputDto {
  export type AttendeesModeEnum = 'preset' | 'manual';
  export const AttendeesModeEnum = {
    Preset: 'preset' as AttendeesModeEnum,
    Manual: 'manual' as AttendeesModeEnum,
  };
  export type PrivacyEnum = 'public' | 'private' | 'members_only';
  export const PrivacyEnum = {
    Public: 'public' as PrivacyEnum,
    Private: 'private' as PrivacyEnum,
    MembersOnly: 'members_only' as PrivacyEnum,
  };
}
